import React, { useEffect, useRef, useState } from 'react'
import "./contactus.scss"
import Dropdown from 'react-bootstrap/Dropdown';
import Header from '../landing/Header/Header';
import Footer from '../landing/footer/Footer';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Breadcrumb } from 'react-bootstrap';
import axios from 'axios';
import { tomiApiUrl } from "../../utils/Api";

gsap.registerPlugin(ScrollTrigger);

const Contactus = () => {

    const textRef = useRef(null);
    const textRef1 = useRef(null);
    const textRef2 = useRef(null);
    const paraRef = useRef(null);
    const paraRef1 = useRef(null);
    const buttonRefs = useRef([]);

    useEffect(() => {
        const tl = gsap.timeline();

        gsap.set(textRef.current, {
            clipPath: "inset(0% 100% 0% 0%)",
            opacity: 1,
        });

        tl.to(textRef.current, {
            clipPath: "inset(0% 0% 0% 0%)",
            duration: 1,
            ease: "power2.out",
        });
    }, []);

    useEffect(() => {
        gsap.fromTo(
            paraRef.current,
            { opacity: 0, y: 50 },
            { opacity: 1, y: 0, duration: 1, ease: "power2.out" }
        );
    }, []);

    useEffect(() => {
        gsap.from(".breadvrumbcnt, .breadvrumbcntactive", {
            opacity: 0,
            y: 10,
            duration: 0.6,
            stagger: 0.2,
            ease: "power2.out",
        });
    }, []);


    useEffect(() => {
        gsap.set(textRef1.current, {
            clipPath: "inset(0% 100% 0% 0%)",
            opacity: 1,
        });

        gsap.to(textRef1.current, {
            clipPath: "inset(0% 0% 0% 0%)",
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
                trigger: textRef1.current,
                start: "top 80%",
                toggleActions: "play none none none",
            },
        });
    }, []);

    useEffect(() => {
        gsap.set(buttonRefs.current, {
            clipPath: "inset(0% 100% 0% 0%)",
            opacity: 1,
        });

        gsap.to(buttonRefs.current, {
            clipPath: "inset(0% 0% 0% 0%)",
            duration: 0.5,
            ease: "power2.out",
            stagger: 0,
            scrollTrigger: {
                trigger: buttonRefs.current[0],
                start: "top 80%",
                toggleActions: "play none none none",
            },
        });

        gsap.to(buttonRefs.current, {
            rotateY: 360,
            duration: 2,
            ease: "power2.inOut",
            stagger: 0,
            scrollTrigger: {
                trigger: buttonRefs.current[0],
                start: "top 80%",
                toggleActions: "play none none none",
            },
        });
    }, []);


    useEffect(() => {
        gsap.set(textRef2.current, {
            clipPath: "inset(0% 100% 0% 0%)",
            opacity: 1,
        });

        gsap.to(textRef2.current, {
            clipPath: "inset(0% 0% 0% 0%)",
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
                trigger: textRef2.current,
                start: "top 80%",
                toggleActions: "play none none none",
            },
        });
    }, []);


    useEffect(() => {
        gsap.fromTo(
            paraRef1.current,
            { opacity: 0, y: 80 },
            {
                opacity: 1,
                y: 0,
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: paraRef1.current,
                    start: "top 80%",
                    toggleActions: "play none none none",
                },
            }
        );
    }, []);


    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])



    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    });
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [errors, setErrors] = useState({ name: "", email: "", message: "" });

    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

    // const handleChange = (e) => {
    //     setFormData({ ...formData, [e.target.name]: e.target.value });
    // };

    const handleNameChange = (e) => {
        setFormData((prev) => ({ ...prev, name: e.target.value }));
        if (errors.name && e.target.value.trim().length > 0) {
            setErrors((prev) => ({ ...prev, name: "" }));
        }
    };

    const handleEmailChange = (e) => {
        setFormData((prev) => ({ ...prev, email: e.target.value }));
        if (errors.email) {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (emailRegex.test(e.target.value)) {
                setErrors((prev) => ({ ...prev, email: "" }));
            }
        }
    };

    const handleMessageChange = (e) => {
        setFormData((prev) => ({ ...prev, message: e.target.value }));
        if (errors.message && e.target.value.trim().length > 0) {
            setErrors((prev) => ({ ...prev, message: "" }));
        }
    };


    // Validate inputs
    const validateInputs = () => {
        let newErrors = { name: "", email: "", message: "" };
        let isValid = true;

        if (!formData.name.trim()) {
            newErrors.name = "Name is required!";
            isValid = false;
        }

        if (!formData.email.trim()) {
            newErrors.email = "Email is required!";
            isValid = false;
        } else {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailRegex.test(formData.email)) {
                newErrors.email = "Invalid email format!";
                isValid = false;
            }
        }

        if (!formData.message.trim()) {
            newErrors.message = "Message is required!";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };


    const handleSubmit = async (e) => {
        if (!validateInputs()) return;

        e.preventDefault();
        setLoading(true);
        setError(null);
        setResponseMessage(null);

        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (!emailRegex.test(formData.email)) {
            setError("Invalid email format. Please enter a valid email.");
            setLoading(false);
            return;
        }

        try {
            await axios.post(`${tomiApiUrl}contactUs`, formData);
            setResponseMessage("Form submitted successfully!");
            setFormData({ name: "", email: "", message: "" });
            // handleShow();

            // Show success modal
            const successModalEl = document.getElementById("exampleModal1");
            let successModal = window.bootstrap.Modal.getInstance(successModalEl);
            if (!successModal) {
                successModal = new window.bootstrap.Modal(successModalEl);
            }
            successModal.show();


        } catch (error) {
            setError("Submission failed. Try again later.");
        }
        setLoading(false);
    };


    const breadcrumbSchema = {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        "itemListElement": [
            {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://tomi.com/"
            },
            {
                "@type": "ListItem",
                "position": 2,
                "name": "Contact Us",
                "item": "https://tomi.com/contactus"
            }
        ]
    };

    useEffect(() => {
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.innerHTML = JSON.stringify(breadcrumbSchema);
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, []);


    useEffect(() => {
        document.title = "Contact Us - tomi ";

        const metaDescription = document.querySelector("meta[name='description']");
        if (metaDescription) {
            metaDescription.setAttribute(
                "content",
                "Looking to reach out to us? fostering an environment where freedom of speech we will naturally have our contact information for you to reach out - Send Your Query"
            );
        } else {
            const newMeta = document.createElement("meta");
            newMeta.name = "description";
            newMeta.setAttribute(
                "content",
                "Looking to reach out to us? fostering an environment where freedom of speech we will naturally have our contact information for you to reach out - Send Your Query"
            );
            document.head.appendChild(newMeta);
        }
    }, []);



    return (
        <>
            <Header />
            <section className='maincontact'>
                <img src='\assets\contactbg.png' alt='img' className='img-fluid contact' />
                <img src='\assets\contactmobileimg.png' alt='contactusimg' className='img-fluid mblmbl d-none' />
                <div className='custom-container'>
                    <div className='maincontent'>

                        <nav aria-label="breadcrumb">
                            <Breadcrumb className="breadcrumbprnt">
                                <Breadcrumb.Item className="breadvrumbcnt" href="/">
                                    Home
                                </Breadcrumb.Item>
                                <Breadcrumb.Item className="breadvrumbcnt">
                                    Help
                                </Breadcrumb.Item>
                                <Breadcrumb.Item
                                    className="breadvrumbcntactive"
                                >
                                    Contact Us
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </nav>
                        <h1 className='blackpara' ref={textRef}>We’re here to connect with you.</h1>
                    </div>
                </div>
            </section>
            <section className='connectwithtomi'>
                <img src='\assets\contactshade.png' alt='img' className='img-fluid shade' />
                <div className='custom-container'>
                    <div className='parent'>
                        <div className='left'>
                            <h2 className='upperhead' ref={textRef2}>Let’s Connect! Reach Out Anytime!</h2>
                            <div ref={paraRef1}>
                                <p className='para'>Have questions or need support? We’re here to help! Use the contact form to reach out to us, and our team will get back to you as soon as possible.</p>
                                <p className='para'>Stay connected and join the conversation in our social communities:</p>
                            </div>
                            {/* <div className='innerparentmain' ref={sectionRef}>
                                <div className='parentinner' ref={(el) => (cardRefs.current[0] = el)}>
                                    <div className='innerleft'>
                                        <img src='\assets\pinkpic.svg' alt='img' className='img-fluid innerpink' />
                                    </div>
                                    <div className='innerright'>
                                        <h5>Twitter</h5>
                                        <p>Get updates, news, and announcements.</p>
                                    </div>
                                </div>
                                <div className='parentinner' ref={(el) => (cardRefs.current[1] = el)}>
                                    <div className='innerleft'>
                                        <img src='\assets\pinkpic1.svg' alt='img' className='img-fluid innerpink' />
                                    </div>
                                    <div className='innerright'>
                                        <h5>Telegram</h5>
                                        <p>Engage with our community and share your thoughts.</p>
                                    </div>
                                </div>
                                <div className='parentinner' ref={(el) => (cardRefs.current[2] = el)}>
                                    <div className='innerleft'>
                                        <img src='\assets\pinkpic2.svg' alt='img' className='img-fluid innerpink' />
                                    </div>
                                    <div className='innerright'>
                                        <h5>Discord</h5>
                                        <p>Collaborate, chat, and connect with like-minded users.</p>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                        <div className='right'>
                            <h2 className='rightheading'>Connect With TOMI</h2>
                            <p>Reach out to us directly by filling out the form below.</p>
                            <input
                                type="text"
                                name="name"
                                placeholder="Your Name"
                                value={formData.name}
                                onChange={handleNameChange}
                                required
                                className={errors.name ? "error" : ""}
                            />
                            {errors.name && <p className='error-text'>{errors.name}</p>}

                            <input
                                placeholder='Email Address'
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleEmailChange}
                                required
                                className={errors.email ? 'error' : ""}

                            />
                            {errors.email && <p className='error-text'>{errors.email}</p>}

                            {/* <div className='maindrop'>
                                <Dropdown>
                                    <Dropdown.Toggle id="dropdown-basic">
                                        Subject
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3642 6.86364L15.0006 6.22724L16.2734 7.50003L15.637 8.13643L10.637 13.1364L10.0006 13.7728L9.36425 13.1364L8.7597 12.5319L10.0144 11.2135L14.3642 6.86364ZM9.47981 10.7064L7.50859 11.2808L4.36425 8.13643L3.72785 7.50003L5.00065 6.22724L5.63704 6.86364L9.47981 10.7064Z" fill="black" />
                                        </svg>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                                        <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                        <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div> */}
                            <textarea
                                name="message"
                                placeholder="Your Message"
                                value={formData.message}
                                onChange={handleMessageChange}
                                required
                                className={errors.message ? "error" : ""}
                            />
                            {errors.message && <p className='error-text'>{errors.message}</p>}

                            <div className='endbtnbtn'>
                                {/* <button className='submit primerybtn' onClick={handleSubmit} >{loading ? "Submitting..." : "I'm In!"}</button> */}
                                <button
                                    type="button"
                                    className="submit primerybtn"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    {loading ? "Submitting..." : "Submit"}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className='brdr'></div>
                    <div className='lastcontent'>
                        <h2 style={{ maxWidth: "450px", textAlign: "center" }} ref={textRef1}>Follow us for the latest updates and join the conversation.</h2>
                        <div className='social'>
                            <a href='https://twitter.com/tomipioneers' rel="me" target='_blank' ref={(el) => (buttonRefs.current[0] = el)}> <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                <path d="M25.189 8H29.0224L20.6474 17.5308L30.5 30.5H22.7855L16.7432 22.6342L9.82948 30.5H5.99367L14.9516 20.3057L5.5 8H13.4103L18.872 15.1896L25.189 8ZM23.8435 28.2154H25.9677L12.2561 10.1646H9.97666L23.8435 28.2154Z" fill="#0E1120" />
                            </svg></a>
                            <a href='https://t.me/tomi_official_chat' rel="me" target='_blank' ref={(el) => (buttonRefs.current[1] = el)}> <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                <path d="M16.025 20.5223L15.6445 25.827C16.1889 25.827 16.4246 25.5952 16.7074 25.3169L19.2595 22.8992L24.5477 26.7381C25.5175 27.2739 26.2008 26.9917 26.4625 25.8536L29.9336 9.73033L29.9346 9.72938C30.2422 8.30818 29.4161 7.75244 28.4712 8.10108L8.06778 15.8445C6.67529 16.3803 6.69637 17.1498 7.83107 17.4984L13.0474 19.1068L25.1639 11.5914C25.7341 11.2171 26.2526 11.4242 25.8261 11.7985L16.025 20.5223Z" fill="#0E1120" />
                            </svg></a>
                            <a href='https://www.youtube.com/@tomipioneers' rel="me" target='_blank' ref={(el) => (buttonRefs.current[2] = el)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                    <path d="M33 14.2145C33 10.776 30.0796 8 26.4624 8H9.53761C5.92035 8 3 10.776 3 14.2145V21.7855C3 25.224 5.92035 28 9.53761 28H26.4624C30.0796 28 33 25.224 33 21.7855V14.2145ZM22.3142 18.3785L15.5774 21.9117C15.2788 22.0694 15.0133 21.8486 15.0133 21.5331V14.3091C15.0133 13.9937 15.2788 13.7729 15.5774 13.9306L22.3805 17.6215C22.6792 17.8107 22.6128 18.2208 22.3142 18.3785Z" fill="#0E1120" />
                                </svg></a>
                            <a href='https://discord.com/invite/tomipioneers' rel="me" target='_blank' ref={(el) => (buttonRefs.current[3] = el)}> <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                <path d="M13.9244 8C13.0437 8 10.3886 9.11939 9.91226 9.34309C9.43592 9.5668 8.90719 10.2651 8.30725 11.4177C7.7065 12.5703 7.22443 13.9176 6.44115 15.8995C5.6587 17.8814 5.47619 21.7023 5.50238 22.8684C5.52857 24.0346 5.65707 24.9456 6.80701 25.6354C7.95613 26.3244 8.97266 27.0457 10.0424 27.4795C11.1129 27.9133 11.843 28.2255 12.339 27.7917C12.835 27.3579 13.1616 26.5983 13.1616 26.5983C13.1616 26.5983 13.6314 25.9204 12.7441 25.5138C11.8569 25.1063 11.4133 24.8214 11.4518 24.4012C11.4911 23.981 11.5557 23.7505 11.7775 23.8049C11.9993 23.8594 12.5223 24.835 14.5317 25.2824C16.541 25.7298 18.4996 25.6626 18.4996 25.6626C18.4996 25.6626 20.459 25.7307 22.4683 25.2824C24.4777 24.835 24.9998 23.8594 25.2216 23.8049C25.4434 23.7505 25.5081 23.981 25.5474 24.4004C25.5867 24.8214 25.1431 25.1063 24.2559 25.5138C23.3686 25.9204 23.8384 26.5983 23.8384 26.5983C23.8384 26.5983 24.165 27.357 24.661 27.7917C25.1562 28.2255 25.8871 27.9133 26.9568 27.4795C28.0265 27.0457 29.0439 26.3253 30.193 25.6354C31.3429 24.9456 31.4714 24.0346 31.4976 22.8684C31.5238 21.7031 31.3413 17.8814 30.558 15.8995C29.7756 13.9176 29.2927 12.5703 28.6919 11.4177C28.0928 10.2651 27.5633 9.5668 27.0877 9.34224C26.6114 9.11939 23.9555 8 23.0748 8C22.1941 8 21.9339 8.63795 21.9339 8.63795L21.6269 9.34309C21.6269 9.34309 19.5644 8.93566 18.5135 8.93481C17.4626 8.93481 15.3731 9.34309 15.3731 9.34309L15.0661 8.6371C15.0661 8.6371 14.8059 8 13.9244 8ZM14.0201 16.4617H14.0529C15.337 16.4617 16.3773 17.6296 16.3773 19.0697C16.3773 20.5106 15.337 21.6776 14.0529 21.6776C12.7687 21.6776 11.7284 20.5106 11.7284 19.0697C11.7276 17.6432 12.7491 16.4813 14.0201 16.4617ZM22.9471 16.4617H22.9799C24.2509 16.4813 25.2716 17.6441 25.2716 19.0697C25.2716 20.5106 24.2313 21.6776 22.9471 21.6776C21.6621 21.6776 20.6227 20.5106 20.6227 19.0697C20.6227 17.6296 21.6621 16.4617 22.9471 16.4617Z" fill="#0E1120" />
                            </svg></a>
                            <a href='https://www.linkedin.com/company/tomidotcom' rel="me" target='_blank' ref={(el) => (buttonRefs.current[4] = el)}> <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                <path d="M30.5 20.6829V30.0403C30.5 30.2702 30.3118 30.4672 30.0922 30.4672H25.4812C25.2616 30.4672 25.0734 30.2702 25.0734 30.0403V21.3396C25.0734 19.0413 24.2892 17.4653 22.3131 17.4653C20.8074 17.4653 19.9291 18.5159 19.5213 19.5338C19.3645 19.8949 19.3331 20.4203 19.3331 20.9128V30.0403C19.3331 30.2702 19.1449 30.4672 18.9253 30.4672H14.3457C14.1261 30.4672 13.9379 30.2702 13.9379 30.0403C13.9379 27.7092 14.0006 16.4475 13.9379 13.8208C13.9379 13.591 14.1261 13.394 14.3457 13.394H18.9567C19.1763 13.394 19.3645 13.591 19.3645 13.8208V15.8236C19.3645 15.8565 19.3331 15.8565 19.3331 15.8893H19.3645V15.8236C20.0859 14.6745 21.372 13 24.2578 13C27.8338 13 30.5 15.4625 30.5 20.6829ZM5.90778 30.5H10.5188C10.7384 30.5 10.9266 30.303 10.9266 30.0732V13.8208C10.9266 13.591 10.7384 13.394 10.5188 13.394H5.90778C5.68821 13.394 5.5 13.591 5.5 13.8208V30.0732C5.53137 30.303 5.68821 30.5 5.90778 30.5Z" fill="#0E1120" />
                                <path d="M8 10.5C9.38071 10.5 10.5 9.38071 10.5 8C10.5 6.61929 9.38071 5.5 8 5.5C6.61929 5.5 5.5 6.61929 5.5 8C5.5 9.38071 6.61929 10.5 8 10.5Z" fill="#0E1120" />
                            </svg></a>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />

            {/* Success Modal */}
            <div className="modaltopdivhome">
                <div className="modal fade" id="exampleModal1" tabIndex="-1" aria-labelledby="exampleModalLabel1" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title fs-5" id="exampleModalLabel1"></h1>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="modaltickerprnt">
                                    <div className="cntmodalhome">
                                        <img src="\assets\contactus-msgicon.png" alt="tickimg" />
                                        <h2>Thank you for reaching out!</h2>
                                        <p>Someone from our team will get in touch with you shortly.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="modaldonebtn" data-bs-dismiss="modal">
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Contactus